import React, { useEffect } from 'react';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import { useVoyagerStore } from '../../stores/useVoyagerStore';
import type { LandingAgentTurn } from '../../stores/slices/landingAgentSlice';
import Box from '@mui/material/Box';
import { stromaCompactPanel } from './askPresentation';

export default function AnalysisRecovery({ turn }: { turn: LandingAgentTurn }) {
  const resume = useVoyagerStore(s => s.sendLandingAgentQuery);
  const stop = useVoyagerStore(s => s.stopBackgroundAnalysis);
  const generation = useVoyagerStore(s => s.threadsGeneration);
  const awaiting = turn.status === 'running' || !!turn.analysisAwaitingLadder;
  useEffect(() => {
    if (turn.analysisOperationId && awaiting && !turn.stopped && !turn.analysisDisconnected)
      resume(turn.userText, { resumeTurnId: turn.id });
  }, [resume, generation, turn.id, turn.analysisOperationId, awaiting, turn.stopped, turn.analysisDisconnected, turn.userText]);
  useEffect(() => {
    if (turn.analysisCancelPending && !turn.analysisDisconnected) void stop(turn.id);
  }, [stop, generation, turn.id, turn.analysisCancelPending, turn.analysisDisconnected]);
  if (turn.analysisCancelPending) return <Alert severity="warning" sx={stromaCompactPanel}>Stop requested. Waiting for server confirmation.
    {turn.analysisDisconnected && <Button onClick={() => void stop(turn.id)}>Retry Stop</Button>}
  </Alert>;
  if (turn.stopped || !awaiting) return null;
  // F4 (#1858 §5): Stop is the composer's; this keeps only reconnecting and finishing delivery
  if (!turn.analysisDisconnected && !turn.analysisAwaitingLadder) return null;
  const content = <>
    {turn.analysisDisconnected && <Button onClick={() => resume(turn.userText, { resumeTurnId: turn.id })}>Reconnect to analysis</Button>}
    {turn.analysisAwaitingLadder && !turn.analysisDisconnected && 'Finishing answer delivery…'}
  </>;
  return <Box sx={{ ...stromaCompactPanel, p: 1.25, display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>{content}</Box>;
}
